import "./App.css";
import { SectionMotion } from "./motion/SectionMotion";
import { InkBoil } from "./motion/InkBoil";
import { UnderlineScroll } from "./motion/UnderlineScroll";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/Header";
import { CartProvider, useCart } from "./context/CartContext";
import { CartPopup } from "./components/CartPopup";
import { CookieConsent } from "./components/CookieConsent";

// Scroll to top on route change (but not when navigating with hash)
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (location.hash) {
        try { document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView({behavior: 'instant'}); } catch { /* Ignore malformed fragments. */ }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [location.pathname, location.hash]);
  
  return null;
};

// Cart popup wrapper
const CartWrapper = () => {
  const { showCart, setShowCart } = useCart();
  
  if (!showCart) return null;
  
  return <CartPopup onClose={() => setShowCart(false)} />;
};
import { HeroSection } from "./components/HeroSection";
import { CoursesSection } from "./components/CoursesSection";
import { BentoSection } from "./components/BentoSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { PricingSection } from "./components/PricingSection";
import { LearningProcessSection } from "./components/LearningProcessSection";
import { CertificateSection } from "./components/CertificateSection";
import { CTASection } from "./components/CTASection";
import { Footer } from "./components/Footer";
import { AuthorSection } from "./components/AuthorSection";
import { CoursePage } from "./pages/CoursePage";
import { AllCoursesPage } from "./pages/AllCoursesPage";
import { PublicOfferPage } from "./pages/PublicOfferPage";
import { PersonalDataConsentPage } from "./pages/PersonalDataConsentPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage";
import { PaymentFailedPage } from "./pages/PaymentFailedPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PaymentServicePage } from "./pages/PaymentServicePage";
import { FAQSection } from "./components/FAQSection";
import { BlogPage, ArticlePage } from "./pages/BlogPage";
import SEO from "./components/SEO";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title={null}
        description="Обучение дизайну, программированию и нейросетям с нуля до профессионала. Figma, Photoshop, JavaScript, React, AI и многое другое. Пожизненный доступ и поддержка преподавателя."
        url="/"
      />
      <Header />
      <HeroSection />
      <CoursesSection />
      <BentoSection />
      <LearningProcessSection />
      <AuthorSection />
      <TestimonialsSection />
      <CertificateSection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {

  return (
    <HelmetProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <SectionMotion />
            <InkBoil />
          <UnderlineScroll />
            <CartWrapper />
            <CookieConsent />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<ArticlePage />} />
              <Route path="/courses" element={<AllCoursesPage />} />
              <Route path="/course/:slug" element={<CoursePage />} />
              <Route path="/public-offer" element={<PublicOfferPage />} />
              <Route path="/personal-data-consent" element={<PersonalDataConsentPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/failed" element={<PaymentFailedPage />} />
              {/* <Route path="/payment-service" element={<PaymentServicePage />} /> */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
